// swr.js

(function(window, document, $, undefined) {
  var SWRNEU = {};

  function expose() {
    var oldSWR = window.SWRNEU;

    SWRNEU.noConflict = function() {
      window.SWRNEU = oldSWR;
      return this;
    };

    window.SWRNEU = SWRNEU;
  }

  if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = SWRNEU;
  } else if (typeof define === 'function' && define.amd) {
    define(SWRNEU);
  }

  if (typeof window !== 'undefined') {
    expose();
  }

}(window, document, window.jQuery));
